var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Container',[_c('v-row',_vm._l((_vm.bannerItems),function(i,index){return _c('v-col',{key:index,attrs:{"cols":"12","sm":"4"}},[_c('BannerItem',_vm._b({},'BannerItem',i,false))],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }